export default __webpack_public_path__ + "static/media/03_Rijnhuizerbrug_2-nieuwe situatie_v2.0.9286ff6d.jpg";